import { MyZoo, Send } from "nzk-react-components"
import React, { useMemo } from "react"
import useIpTrace from "../../hooks/useIpTrace"
import * as s from "./index.styles"

interface IProps {
  discountLabel: string
  onClaim: () => void
  onSkip: () => void
}

const EU_OFFER_URL = "https://www.nightzookeeper.com/eu/parents/special_offers/eu-offer"

const EU_COUNTRIES = [
  "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR",
  "DE", "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL",
  "PL", "PT", "RO", "SK", "SI", "ES", "SE", "NO", "CH",
]

const SPECIAL_OFFERS_MAP: Record<string, string> = {
  US: "https://www.nightzookeeper.com/en-us/parents/special_offers/1",
  GB: "https://www.nightzookeeper.com/en-gb/parents/special-offer",
  CA: "https://www.nightzookeeper.com/en-ca/parents/special_offers/ca-offer",
  AU: "https://www.nightzookeeper.com/en-au/parents/special_offers/au-offer",
  HK: "https://www.nightzookeeper.com/en-hk/parents/special_offers/hk-offer",
  NZ: "https://www.nightzookeeper.com/en-nz/parents/special_offers/nz-offer",
  ZA: "https://www.nightzookeeper.com/en-za/parents/special_offers/za-offer",
  PH: "https://www.nightzookeeper.com/en-ph/parents/special_offers/php-offer",
  SG: "https://www.nightzookeeper.com/en-sg/parents/special_offers/sg-offer",
  ...Object.fromEntries(EU_COUNTRIES.map(c => [c, EU_OFFER_URL])),
}

const DEFAULT_OFFER_URL = SPECIAL_OFFERS_MAP.US

const SpecialOfferComponent = ({ discountLabel, onClaim, onSkip }: IProps) => {
  const { ipTraceInfo } = useIpTrace()

  const offerUrl = useMemo(() => {
    const country = ipTraceInfo?.loc
    if (country && SPECIAL_OFFERS_MAP[country]) {
      return SPECIAL_OFFERS_MAP[country]
    }
    if (typeof navigator !== "undefined" && navigator.language) {
      const localeCountry = navigator.language.split("-")[1]?.toUpperCase()
      if (localeCountry && SPECIAL_OFFERS_MAP[localeCountry]) {
        return SPECIAL_OFFERS_MAP[localeCountry]
      }
    }
    return DEFAULT_OFFER_URL
  }, [ipTraceInfo])


  return (
    <>
      <s.InboxMessage>
        <div className="icon"><Send /></div>
        <div className="text">Your free resource pack is on its way to your inbox!</div>
      </s.InboxMessage>
      <s.OfferBadge>Special offer — Just for you</s.OfferBadge>
      <s.OfferImage src="/images/gang_behind_device_glow.png" alt="Night Zookeeper" />
      <s.OfferDiscount>{discountLabel}</s.OfferDiscount>
      <s.OfferPlanName>vs monthly pricing</s.OfferPlanName>
      <s.FormWrapper>
        <s.ScrollWrapper>
          <s.OfferDescription>
            Make reading and writing <br /><em>fantastically fun</em> for your child <br />with Night Zookeeper.
            <MyZoo style={{ marginLeft: '8px' }} fontSize={20} />
          </s.OfferDescription>
          {/* <s.PriceCard> */}
          {/*   <s.PriceSide> */}
          {/*     <span className="label">Was</span> */}
          {/*     <span className="price striked">{oldPrice}</span> */}
          {/*   </s.PriceSide> */}
          {/*   <s.PriceDivider /> */}
          {/*   <s.PriceSide highlight> */}
          {/*     <span className="label">Now</span> */}
          {/*     <span className="price">{newPrice}</span> */}
          {/*   </s.PriceSide> */}
          {/* </s.PriceCard> */}
        </s.ScrollWrapper>
      </s.FormWrapper>
      <s.SubmitButton title={offerUrl} onClick={() => {
        window.location.href = offerUrl
        onClaim()
      }}>Claim My Discount</s.SubmitButton>
      <s.SkipLink onClick={onSkip}>No thanks, I'm not interested</s.SkipLink>
    </>
  )
}

export default SpecialOfferComponent
